import { loginRequest, logoutRequest, getUserRequest, loginRequestGoogleCode } from "../../utils/kbt-api";
import { AppDispatch } from "../hooks";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_PENDING = "LOGIN_PENDING";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";
export const LOGOUT_PENDING = "LOGOUT_PENDING";

export const SET_AUTH_CHECKED = "SET_AUTH_CHECKED";
export const SET_USER = "SET_USER";
export const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";

export const setAuthChecked = (value: boolean) => ({
  type: SET_AUTH_CHECKED,
  payload: value,
});

export const setUser = (user: any) => ({
  type: SET_USER,
  payload: user,
});

export const login = (email: string, password: string) => (dispatch: AppDispatch) => {
  dispatch({
    type: LOGIN_PENDING,
  });

  loginRequest(email, password)
    .then(() => {
      dispatch({
        type: LOGIN_SUCCESS,
      });

      return getUserRequest();
    })
    .then((res) => dispatch(setUser(res)))
    .catch(() => {
      dispatch({
        type: LOGIN_ERROR,
      });
    });
};

export const loginWithGoogleCode = (queryString: string) => (dispatch: AppDispatch) => {
  dispatch({
    type: LOGIN_PENDING,
  });

  return loginRequestGoogleCode(queryString)
    .then(() => {
      dispatch({
        type: LOGIN_SUCCESS,
      });

      return getUserRequest();
    })
    .then((res) => {
      dispatch(setUser(res));
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOGIN_ERROR,
      });

      throw err;
    });
};

export const logout = () => (dispatch: AppDispatch) => {
  dispatch({
    type: LOGOUT_PENDING,
  });

  dispatch(setUser(null));

  logoutRequest()
    .then(() => {
      dispatch({
        type: LOGOUT_SUCCESS,
    });
    })
    .catch(() => {
      dispatch({
        type: LOGOUT_ERROR,
      });
    });
};

export const checkUserAuth = () => (dispatch: AppDispatch) => {
  if (localStorage.getItem("accessToken")) {
    getUserRequest()
      .then((res) => dispatch(setUser(res)))
      .finally(() => dispatch(setAuthChecked(true)));
  } else {
    dispatch(setAuthChecked(true));
  }
};

export const getUser = () => {
  return (dispatch: AppDispatch) => {
    getUserRequest()
      .then((res) => dispatch(setUser(res)))
      .catch(() => {});
  };
};

export type TLoginActions = any;
